import { Component, Input } from '@angular/core';

@Component({
    selector: 'ca-alert-panel',
    templateUrl: './alert-panel.html',
    styleUrls: ['./alert-panel.scss'],
    standalone: false
})
export class CaAlertPanel {
  @Input()
  displayEmblem: boolean = true;
}
